import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { raygunHttpError } from '@approot/app.raygun.setup';
import { AlertsService, AuthService } from '@approot/services';
import { Observable, throwError, catchError } from 'rxjs';
import { DeltaHedgeDto } from './delta-hedges.component';

@Injectable({ providedIn: 'root' })
export class DeltaHedgesService {
  constructor(
    private alertsService: AlertsService,
    private authService: AuthService
  ) {}

  public getDeltaHedgingOrders(
    date: string,
    time: string,
    timezone: string
  ): Observable<{ orders: DeltaHedgeDto[] }> {
    return this.getUserInfo<{ orders: DeltaHedgeDto[] }>({
      task: 'getDeltaHedgingOrders',
      date,
      time,
      timezone
    });
  }

  private handleError(error: HttpErrorResponse) {
    this.alertsService.addHttpAlert({ error });
    return throwError(
      () => new Error('Something bad happened; please try again later.')
    );
  }

  private getUserInfo<T>(params: Record<string, string>): Observable<T> {
    const httpParams = new HttpParams().appendAll(params).toString();
    return this.authService.fxPost<T>(params, `get-user-info`, httpParams).pipe(
      catchError(err => {
        raygunHttpError(err, ['get-user-info']);
        return this.handleError(err);
      })
    );
  }
}
